<script>
import Layout from "../../layouts/main";
import axios from "axios";
import Swal from "sweetalert2";
import {mapState} from "vuex";
import {cloneDeep} from 'lodash';


/**
 * Projects-list component
 */
export default {
  page: {
    title: "Campaigns",
  },
  components: {Layout},
  methods: {
    truncateString(input, limit = 40) {
      if (input.length > limit) {
        return input.substring(0, limit) + '...';
      }
      return input;
    },
    finishCampaign(campaign) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#868585",
        confirmButtonText: "Yes, mark as finish!"
      }).then(result => {
        if (result.value) {
          axios.post(`/client/campaign/${campaign.id}/finished`).then(() => {

            this.$store.commit('campaign/MARK_AS_FINISHED', campaign);
            Swal.fire("Finished!", "The campaign has been marked as finished.", "success");
          })
        }
      });

    }
  },
  data() {
    return {
      search: '',
      title: "Campaigns",
      statusFilter: 'active'
    };
  },
  computed: {
    ...mapState('campaign', {
      campaigns: (state) => cloneDeep(state.campaigns).map(campaign => {
        campaign.id = campaign._id;
        campaign.influencers = [];

        let statuses = {}
        if (campaign.campaign_agreements_by_status) {
          statuses = Object.keys(campaign.campaign_agreements_by_status).reduce((result, item) => {
            result[item] = campaign.campaign_agreements_by_status[item].length
            return result
          }, {})

          if (campaign.campaign_agreements_by_status.signed) {
            for (let agreement of campaign.campaign_agreements_by_status.signed) {
              if (agreement.influencer_profile_basic) {
                let name = agreement.influencer_profile_basic.name;
                if (agreement.influencer_profile_basic.username && agreement.influencer_profile_basic.username.length >0) {
                  name = agreement.influencer_profile_basic.username;
                }
                campaign.influencers[agreement.influencer_profile_basic._id] = ({
                  id: agreement.influencer_profile_basic._id,
                  image: agreement.influencer_profile_basic.profile_picture_url,
                  name: name
                })
              }
            }
            campaign.influencers = Object.values(campaign.influencers)
          }
        }
        campaign.offer = statuses.offer ?? 0;
        campaign.interested = statuses.interested ?? 0;
        campaign.pending = statuses.pending ?? 0;
        campaign.canceledAndAborted = (statuses.canceled ?? 0) + (statuses.aborted ?? 0);
        campaign.expired = statuses.expired ?? 0

        return campaign;
      })
    }),
    filteredCampaigns () {
      if (this.statusFilter === 'all') {
        return this.searchedCampaigns;
      } else {
        return this.searchedCampaigns.filter(item => item.tag === this.statusFilter);
      }

    },
    searchedCampaigns() {
      return this.campaigns.filter((campaign) => campaign.internal_name.toLowerCase().includes(this.search.toLowerCase()))
    }
  },
};
</script>

<template>
  <Layout>
    <div v-if="this.campaigns.length === 0">
      <div class="col">
        <div class="card">
          <div>
            <div class="row">
              <div class="col-lg-9 col-sm-8">
                <div class="p-4">
                  <h5 class="text-primary">Create your first campaign</h5>
                  <p>You will be able to access features:</p>

                  <div class="text-muted">
                    <p class="mb-1">
                      <i class="mdi mdi-circle-medium align-middle text-primary mr-1"></i>
                      Live analytics & Reporting
                    </p>
                    <p class="mb-1">
                      <i class="mdi mdi-circle-medium align-middle text-primary mr-1"></i>
                      Posts analysis
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-circle-medium align-middle text-primary mr-1"></i>
                      Campaign planning
                    </p>
                  </div>

                  <b-button @click="$router.push('/client/campaigns/create')" class="col-sm-12 col-md-5 mt-4"
                            variant="primary">
                    Create Campaign
                  </b-button>

                </div>
              </div>
              <div class="col-lg-3 col-sm-4 align-self-center">
                <div class="connect-card">
                  <img
                      :src="require(`@/assets/images/loudspeaker.png`)"
                      alt
                      class="img-fluid d-block connect-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row ">
        <div class="col-md-6 search-box chat-search-box mb-2">
          <div class="position-relative">
            <input v-model="search" type="text" class="form-control" placeholder="Search..."/>
            <i class="bx bx-search-alt search-icon"></i>
            <i class="bx bx-x clear-icon" @click="search = ''"></i>
          </div>
        </div>

        <div class="col-md-6 text-right mb-2">
          <b-button @click="$router.push('/client/campaigns/create')" class="col-sm-12 col-md-5" variant="primary">
            Create Campaign
          </b-button>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class>
            <div class="d-flex justify-content-end mt-3">
              <b-dropdown dropleft variant="info" size="sm">
                <template slot="button-content">
                  <i class="mdi mdi-chevron-left"></i>
                  Status: <span style="text-transform: capitalize">{{ statusFilter }}</span>
                </template>
                <b-dropdown-item-button @click="statusFilter = 'active'">Active</b-dropdown-item-button>
                <b-dropdown-item-button @click="statusFilter = 'finished'">Finished</b-dropdown-item-button>
                <b-dropdown-item-button @click="statusFilter = 'all'">All</b-dropdown-item-button>
              </b-dropdown>
            </div>
            <div class="table-responsive">
              <table class="table project-list-table table-nowrap table-centered table-borderless pb-5">
                <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Name</th>
                  <th scope="col" class="text-right">Offer</th>
                  <th scope="col" class="text-right">Interested</th>
                  <th scope="col" class="text-right">Pending</th>
                  <th scope="col" class="text-right">Canceled & Aborted</th>
                  <th scope="col" class="text-right">Expired</th>
                  <th scope="col" class="text-right">Signed</th>
                  <th scope="col" class="text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr class="text-center" v-if="searchedCampaigns.length === 0 && search">
                  <td colspan="10">
                    There are no campaigns that match a given filter: <strong>{{ search }}</strong>
                  </td>
                </tr>
                <tr v-else-if="!filteredCampaigns.length">
                  <td colspan="9" class="text-center">
                    No campaigns.
                  </td>
                </tr>
                <tr v-for="campaign in filteredCampaigns" :key="campaign.id">
                  <td>
                    <router-link :to="`/client/campaigns/${campaign.id}`">
                      <img v-if="campaign.image_url" :src="`${campaign.image_url}`" alt class="avatar-sm"/>
                      <div v-else class="avatar-xs letter-in-circle-2" :style="{background: campaign.color}">
                        {{ campaign.internal_name.charAt(0) }}
                      </div>
                    </router-link>
                  </td>
                  <td>
                    <h5 class="text-truncate font-size-14">
                      <router-link :to="`/client/campaigns/${campaign.id}`" class="text-dark">
                        {{ campaign.internal_name }}
                        <span class="text-capitalize badge badge-soft-warning font-size-12 ml-1 align-bottom">{{ campaign.tag }}</span>
                      </router-link>
                    </h5>
                    <p v-if="campaign.description" class="text-muted mb-0">{{
                        truncateString(campaign.description)
                      }}</p>
                  </td>
                  <td class="text-right">{{ campaign.offer }}</td>
                  <td class="text-right">{{ campaign.interested }}</td>
                  <td class="text-right">{{ campaign.pending }}</td>
                  <td class="text-right">{{ campaign.canceledAndAborted }}</td>
                  <td class="text-right">{{ campaign.expired }}</td>
                  <td class="text-right">
                    <div class="team" v-if="campaign.influencers.length > 0">
                      <router-link v-for="influencer in campaign.influencers.slice(0,3)" :key="influencer.id" tag="a"
                                   class="team-member d-inline-block" :to="`/client/influencers/${influencer.id}`">
                        <img v-if="influencer.image" :src="`${influencer.image}`"
                             class="rounded-circle avatar-xs border-1 ml-minus-5" alt/>
                        <div v-else class="avatar-xs letter-in-circle border-1 ml-minus-5" style="background: gray">
                          {{ influencer.name.charAt(0) }}
                        </div>
                      </router-link>
                      <span v-if="campaign.influencers.length > 3" class="team-member d-inline-block">
                        <div class="avatar-xs letter-in-circle border-1 ml-minus-5"
                             style="background: #dfe1e6; color: #7a869a">+{{ campaign.influencers.length - 3 }}
                        </div>
                      </span>

                    </div>
                    <div v-else>
                      None
                    </div>
                  </td>
                  <td class="text-center">
                    <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                      <template v-slot:button-content>
                        <i class="mdi mdi-dots-vertical font-size-18"></i>
                      </template>
                      <b-dropdown-item @click="finishCampaign(campaign)">Mark as finished</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->

    </div>
  </Layout>
</template>
